import $ from 'jquery';

export default function (params) {
	let $this,
		config = {
			selectBlock: '',
			inputId: ''
		},
		$inpuId,
		$btnPlus,
		$btnMinus,
		$viewQt,
		qtChange;

	/**
	 * metod init
	 */
	function init() {
		$this = $(config.selectBlock);
		$inpuId = $(config.inputId, $this);
		$btnPlus = $('.js_activ-plus', $this);
		$btnMinus = $('.js_activ-minus', $this);
		$viewQt = $('.js_passsenger-qt', $this);

		renderView();
		subscription();
	}
	/**
	 * event
	*/
	function subscription() {
		$btnPlus.on('click', function(){
			testChange('incr');
		});
		$btnMinus.on('click', function(){
			testChange('decr');
		});
	}
	/**
	 * metod test Change
	 */
	function testChange(type) {
		qtChange({
			inpuId: config.inputId,
			type: type
		});
	}
	/**
	 * metod setQt
	 */
	function setQt(qt) {
		$inpuId.val(qt);
		renderView();
	}
	/**
	 * metod getQt
	 */
	function getQt() {

		return $inpuId.val();
	}
	/**
	 * metod render
	 */
	function renderView() {
		let qt = getQt();

		testRenderInput(qt);

		$viewQt.text(qt);
	}
	/**
	 * metod test input render
	 */
	function testRenderInput(qt) {
		if (qt > 0) {
			if (!$inpuId.hasClass('c-passenger-item_value')) {
				$inpuId.addClass('c-passenger-item_value');
			}
		} else {
			if ($inpuId.hasClass('c-passenger-item_value')) {
				$inpuId.removeClass('c-passenger-item_value');
			}
		}
	}
	/**
	 * 
	 */

	$.extend(true, config, params || {});
	init();

	return {
		subscribeChange: function (f) {
			qtChange = f;
		},
		setQt: function (qt) {
			setQt(qt);
		},
		getQt: function () {
			return getQt();
		}

	}
}


// WEBPACK FOOTER //
// ./widget/passenger-item.js